import Clarity from "@microsoft/clarity";
import { QueryClientProvider } from "@tanstack/react-query";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { ThemeProvider } from "next-themes";
import ReactDOM from "react-dom/client";
import { Config } from "./config";
import { consumeAgentLogin } from "./lib/agent-login";
import { getEnvPrefix } from "./lib/page-title";
import { queryClient } from "./lib/query-client";
import { DefaultErrorComponent } from "./lib/version-check";
// Import generated route tree.
import { routeTree } from "./routeTree.gen";

if (import.meta.env.PROD) {
  Clarity.init("qfdqv0giv0");
}

const envPrefix = getEnvPrefix(location.hostname);
if (envPrefix) document.title = envPrefix + document.title;

// Handle unhandled promise rejections from PocketBase realtime subscriptions
window.addEventListener("unhandledrejection", (event) => {
  // Check if it's a PocketBase realtime error
  if (event.reason?.message?.includes("Missing or invalid client id")) {
    // Prevent the error from showing in console
    event.preventDefault();
    // Log as debug instead
    console.debug("PocketBase realtime subscription error (suppressed):", event.reason);
  }
});

// Preview envs only: sign in from a `#agent_token=` fragment minted by
// apps/pocketbase/bin/preview-login.py (FANL-1664). Runs before the router
// exists so it never sees the token, and before AuthProvider mounts so the
// session is already in the store on first render.
await consumeAgentLogin(Config.agentLogin());

// Create new router instance.
const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  defaultErrorComponent: DefaultErrorComponent,
});

// Register router instance for type safety.
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

// Render app - PocketBase is already initialized via top-level await
const rootElement = document.getElementById("root")!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    // <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider attribute="class" defaultTheme="light" enableSystem disableTransitionOnChange>
        <RouterProvider router={router} />
      </ThemeProvider>
    </QueryClientProvider>,
    // </StrictMode>,
  );
}
